import React from "react";
import CountUp from "react-countup";

export default function StatsCards() {
  const stats = [
    {
      icon: "mdi mdi-trophy",
      value: 90,
      description: "de proyectos ganados",
    },
    {
      icon: "mdi mdi-account",
      value: 0,
      description: "de rotación de clientes",
    },
    {
      icon: "mdi mdi-chart-pie",
      value: 60,
      description: "del Market Share",
    },
    {
      icon: "mdi mdi-handshake",
      value: 60,
      description: "clientes de últimos 3 años",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2  mt-[100px] justify-items-center   bg-sidom-light  gap-20 container">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex flex-col rounded-lg marca bg-sidom-orange w-[300px] h-[300px] items-center justify-center  text-sidom-dark dark:bg-sidom-gray  dark:text-sidom-light  "
        >
          <div className="flex items-center justify-center w-20 h-20 bg-sidom-blue  rounded-full mb-4">
            <i className={stat.icon + " text-sidom-light text-2xl"}></i>
          </div>
          <div className="text-nowrap text-sidom-light font-bold flex gap-2 ">
            <CountUp end={stat.value} />%
          </div>
          <div className="text-center text-sidom-light">
            <p>{stat.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
